/*
 * LICENSE PROTECTED SOFTWARE
 *
 * Bu yazilim lisans korumasi altindadir.
 * Gecerli lisans olmadan kullanilmasi yasaktir.
 *
 * Kaynak kodunun izinsiz erisimi, kopyalanmasi veya dagitimi
 * hukuki yaptirimslara tabidir.
 * (c) 2026  @cemdemirci0101
 *  bilgi@cemdemirci.com
 * This source code is proprietary and confidential.
 * Unauthorized copying, modification, or distribution
 * of this file, via any medium, is strictly prohibited.
 * (c) 2026 All Rights Reserved.
 */

import React from 'react';
import { useAuth } from '../context/AuthContext';
import { usePageTitle } from '../hooks/usePageTitle';

// Role-based dashboards
import AdminDashboard from './dashboards/AdminDashboard';
import VatandasDashboard from './dashboards/VatandasDashboard';
import MuhtarDashboard from './dashboards/MuhtarDashboard';
import STKDashboard from './dashboards/STKDashboard';
import MeclisBaskaniDashboard from './dashboards/MeclisBaskaniDashboard';

const DashboardPage = () => {
  const { user } = useAuth();
  usePageTitle('Kontrol Paneli');
  const role = user?.role;

  // Meclis Baskani gets dedicated dashboard
  if (role === 'meclis_baskani') {
    return <MeclisBaskaniDashboard />;
  }

  // Admin and Genel Sekreter get admin dashboard
  if (['admin', 'genel_sekreter', 'kent_konseyi_baskani'].includes(role)) {
    return <AdminDashboard />;
  }

  // Muhtar gets muhtar dashboard
  if (role === 'muhtar') {
    return <MuhtarDashboard />;
  }

  // STK gets STK dashboard
  if (role === 'stk') {
    return <STKDashboard />;
  }

  // Default: Vatandaş dashboard
  return <VatandasDashboard />;
};

export default DashboardPage;
